import React, { useEffect, useState } from "react";
import { getClientScopingStatus } from "../../utils/api/endpoints/questionnaire";
import BusinessLockScreen from "../../pages/scoping/BusinessLockScreen";

type ScopingGateProps = {
  children: React.ReactNode;
};

export const BusinessScopingGate: React.FC<ScopingGateProps> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [locked, setLocked] = useState(false);
  const [shareToken, setShareToken] = useState<string | null>(null);
  const [status, setStatus] = useState<string>("NO_SESSION");

  const checkStatus = async () => {
    try {
      const res = await getClientScopingStatus();
      setLocked(res.locked);
      setShareToken(res.shareToken);
      setStatus(res.status || "NO_SESSION");
    } catch (err) {
      console.error("Error checking business scoping lock status:", err);
      // Fallback: do not lock in case of errors
      setLocked(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkStatus();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center text-slate-800 space-y-4">
        <div className="w-10 h-10 rounded-full border-4 border-t-blue-600 border-slate-200 animate-spin"></div>
        <p className="text-slate-500 text-xs tracking-wider">Verifying workspace permissions...</p>
      </div>
    );
  }

  if (locked) {
    return (
      <BusinessLockScreen
        shareToken={shareToken}
        status={status}
        onUnlocked={() => {
          checkStatus();
        }}
      />
    );
  }

  return <>{children}</>;
};

export default BusinessScopingGate;
